import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, CampaignDomainService, UserService} from '../_services';
import {CrudSavePopupComponent} from '../_directives';
import {FormBuilder, Validators} from '@angular/forms';
import {
  Campaign,
  CustomDomain,
  LifelinePhoneSetting,
  LifelinePhoneSettingOptions,
  SessionType,
  SessionTypeLabels,
  User
} from "../_models";
import {takeUntil} from "rxjs/operators";

@Component({
  moduleId: module.id.toString(),
  selector: 'campaign-domain-form',
  templateUrl: './campaign-domain-form.component.html'
})
export class CampaignDomainFormComponent extends CrudSavePopupComponent implements OnInit {
  domain: CustomDomain;
  errors: string[] = [];
  @Output('verify') onVerify: EventEmitter<any> = new EventEmitter<any>();
  @Input('campaign') campaign: Campaign;
  justVerified: boolean = false;
  lifelinePhoneSettings = LifelinePhoneSettingOptions;
  user: User;

  protected allowedSessionTypes = {
    [SessionType.SupportPortal]: [SessionType.SupportPortal, SessionType.LegacySupport],
    [SessionType.LegacySupport]: [SessionType.SupportPortal, SessionType.LegacySupport],
  }

  constructor(protected router: Router,
              protected location: Location,
              protected route: ActivatedRoute,
              protected formBuilder: FormBuilder,
              protected domainService: CampaignDomainService,
              protected alertService: AlertService,
              protected userService: UserService
  ) {
    super(router, location, route, domainService, alertService);
    this.objectName = 'Custom Domain';
    this.userService.getCurrent()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (user: User) => { this.user = user; },
        error => { this.handleError(error); }
      );
  }

  ngOnInit() {
    this.setForm(this.formBuilder.group({
      campaign: [null, Validators.required],
      domain: [null, Validators.required],
      type: [SessionType.LegacySupport, Validators.required],
      name: [null],
      show_phone_link: [LifelinePhoneSetting.Never, Validators.required],
      support_phone: [null],
      is_react: [false],
    }));

    super.ngOnInit();
  }

  verify() {
    if (!this.loading && this.domain) {
      this.loading = true;
      this.domainService.verify(this.domain.id)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (data: CustomDomain) => {
            this.alertService.success('Successfully verified ' + this.domain.domain);
            this.onVerify.emit(data);
            this.justVerified = true;
            this.errors = [];
            this.loading = false;
          },
          error => {
            this.errors = error.error;
            this.loading = false;
          });
    }
  }

  protected onInputDataChanged() {
    this.domain = this.inputData;
    this.isNew = !this.domain || !this.domain.id;
    this.errors = [];
  }

  protected onSaveComplete(data) {
    this.loading = false;
    this.domain = data;
    this.errors = [];
    this.onSave.emit(data);
  }

  close() {
    this.errors = [];
    this.onCancel.emit();
  }

  get sessionTypes() {
    if (this.domain && this.domain.type in this.allowedSessionTypes) {
      return this.allowedSessionTypes[this.domain.type].map((type) => {
        return {value: type, label: SessionTypeLabels[type]};
      });
    }

    return null;
  }

}
